import React, { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

function getInitialTheme() {
  if (typeof window === "undefined") return "light";
  if (document.documentElement.classList.contains("dark")) return "dark";
  return localStorage.getItem("btb-theme") === "dark" ? "dark" : "light";
}

function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  localStorage.setItem("btb-theme", theme);
}

export default function ThemeToggle({ testid = "theme-toggle" }) {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const isDark = theme === "dark";
  return (
    <button
      type="button"
      data-testid={testid}
      aria-label="Toggle colour theme"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="flex h-9 w-9 items-center justify-center border border-border text-foreground transition-colors hover:border-accent hover:text-accent"
    >
      {isDark ? (
        <Sun strokeWidth={1.6} className="h-[18px] w-[18px]" />
      ) : (
        <Moon strokeWidth={1.6} className="h-[18px] w-[18px]" />
      )}
    </button>
  );
}
